module.exports = __webpack_public_path__ + "img/842.d6741e68.png";